import Component from 'flarum/common/Component';
import clsx from 'flarum/common/utils/classList';
export default class ProgressBar extends Component {
  view() {
    return m("div", {
      className: clsx('UiKit-ProgressBar', this.attrs.className, {
        'UiKit-ProgressBar--mini': this.attrs.mini,
        'UiKit-ProgressBar--fancy': this.attrs.fancy,
        'UiKit-ProgressBar--alternate': this.attrs.alternate
      })
    }, m("div", {
      className: "UiKit-ProgressBar-bar",
      style: {
        width: `${this.getProgress()}%`
      }
    }));
  }
  getProgress() {
    return this.attrs.progress;
  }
}
flarum.reg.add('fof-ui-kit', 'common/components/ProgressBar', ProgressBar);